"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nlNL = exports.nlBE = exports.itIT = exports.frLU = exports.frFR = exports.frBE = exports.esES = exports.deDE = exports.deAT = void 0;
var de_AT_1 = require("./de-AT");
Object.defineProperty(exports, "deAT", { enumerable: true, get: function () { return __importDefault(de_AT_1).default; } });
var de_DE_1 = require("./de-DE");
Object.defineProperty(exports, "deDE", { enumerable: true, get: function () { return __importDefault(de_DE_1).default; } });
var es_ES_1 = require("./es-ES");
Object.defineProperty(exports, "esES", { enumerable: true, get: function () { return __importDefault(es_ES_1).default; } });
var fr_BE_1 = require("./fr-BE");
Object.defineProperty(exports, "frBE", { enumerable: true, get: function () { return __importDefault(fr_BE_1).default; } });
var fr_FR_1 = require("./fr-FR");
Object.defineProperty(exports, "frFR", { enumerable: true, get: function () { return __importDefault(fr_FR_1).default; } });
var fr_LU_1 = require("./fr-LU");
Object.defineProperty(exports, "frLU", { enumerable: true, get: function () { return __importDefault(fr_LU_1).default; } });
var it_IT_1 = require("./it-IT");
Object.defineProperty(exports, "itIT", { enumerable: true, get: function () { return __importDefault(it_IT_1).default; } });
var nl_BE_1 = require("./nl-BE");
Object.defineProperty(exports, "nlBE", { enumerable: true, get: function () { return __importDefault(nl_BE_1).default; } });
var nl_NL_1 = require("./nl-NL");
Object.defineProperty(exports, "nlNL", { enumerable: true, get: function () { return __importDefault(nl_NL_1).default; } });
